import { Suspense, lazy } from 'react'
import type { ReactNode } from 'react'
import type { WorldviewSnapshot, LayerKey, VisualMode, CameraItem } from './types'
import type { ViewBounds, FlyToFn, CameraTelemetry } from './GlobePanel'

const GlobePanel = lazy(() => import('./GlobePanel'))

type Props = {
  snapshot: WorldviewSnapshot | null
  layers: Record<LayerKey, boolean>
  mode: VisualMode
  effectStrength?: number
  mapType?: string
  timelineMinute: number
  cameras?: CameraItem[]
  onViewChange?: (bounds: ViewBounds) => void
  onCameraTelemetryChange?: (telemetry: CameraTelemetry) => void
  onFlyToReady?: (fn: FlyToFn) => void
  onEntityClick?: (id: string, name: string, description: string, lat: number, lon: number) => void
  overlayHud?: ReactNode
}

export default function GlobePanelLazy({
  snapshot, layers, mode, effectStrength = 1, mapType = 'dark', timelineMinute, cameras,
  onViewChange, onCameraTelemetryChange, onFlyToReady, onEntityClick, overlayHud,
}: Props) {
  return (
    <Suspense fallback={<div className="small" style={{ paddingTop: 100, textAlign: 'center', color: '#557' }}>Loading globe…</div>}>
      <GlobePanel
        snapshot={snapshot}
        layers={layers}
        mode={mode}
        effectStrength={effectStrength}
        mapType={mapType}
        timelineMinute={timelineMinute}
        cameras={cameras}
        onViewChange={onViewChange}
        onCameraTelemetryChange={onCameraTelemetryChange}
        onFlyToReady={onFlyToReady}
        onEntityClick={onEntityClick}
        overlayHud={overlayHud}
      />
    </Suspense>
  )
}
